module.exports = __webpack_public_path__ + "2be9daa37c1599ca585883acfc77f195.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-1.png
// module id = 1057
// module chunks = 0